export const splitLocaleQueryParams = (locationQuery: any, lowercase?: boolean): { [id: string]: string; } => {

    const ret: { [id: string]: string; } = {};
    if (locationQuery) {
        const queres: string[] = locationQuery.split("&");

        for (let i = 0; i < queres.length; i++) {
            const values: string[] = queres[i].split("=");
            if (!values || values.length < 2)
                continue;
            const valueName = lowercase===true ? values[0].toLowerCase() : values[0];
            if (i === 0 && valueName[0] === '?')
                ret[valueName.substring(1)] = values[1];
            else
                ret[valueName] = values[1];
        }
    }
    return ret;
}

export const parseQueryParams = (params: any): string => {
    let query = '';

    for (const param in params) {
        const value = params[param];
        if (value || value === 0 || value === '0')
            query += `${query[0] ? '&' : ''}${param}=${value}`;
    }
    return query;
}

export const appendQueryParams = (url: string, params: any): string => {
    const query = parseQueryParams(params);
    if (query) {
        if (url)
            return `${url}${url.indexOf('?') > 0 ? '&' : '?'}${query}`;
        else
            return query;
    }
    return url;
}
